import { fyaiFeatures } from "@/mocks/fyai-data";

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  secondary: "bg-secondary-100 text-secondary-900",
  accent: "bg-accent-100 text-accent-900",
};

export default function FyaiFeatures() {
  return (
    <section id="features" className="w-full bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.85fr_1.5fr] lg:gap-16">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900">
            <i className="ri-sparkling-2-fill" />
            功能特色
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            为什么选择风月AI
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            从主动关心你的情绪，到记住你说过的每一句话，风月AI希望成为那个一直都在的陪伴者。
          </p>

          <div className="mt-8 rounded-card border border-primary-200 bg-primary-50 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
              <i className="ri-heart-3-fill text-xl" />
            </span>
            <p className="mt-4 font-heading text-base font-bold text-foreground-950">越聊越懂你</p>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              每一次对话都会沉淀为专属记忆，让AI风月记得你的喜好、心情与每一个重要时刻。
            </p>
          </div>
        </div>

        <ol className="flex flex-col">
          {fyaiFeatures.map((item, index) => (
            <li
              key={item.title}
              className="group flex items-start gap-4 border-t border-background-200 px-1 py-6 transition-colors last:border-b hover:bg-background-100 md:gap-6 md:px-4 md:py-7"
            >
              <span className="w-8 flex-none pt-0.5 font-heading text-xl font-black text-primary-200 md:text-2xl">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span
                className={`flex h-11 w-11 flex-none items-center justify-center rounded-lg md:h-12 md:w-12 ${toneMap[item.tone]}`}
              >
                <i className={`${item.icon} text-xl md:text-2xl`} />
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}